export enum RequestFilterValueTypeEnums {
    STRING = 1,
    NUMBER = 2,
    DATE = 3,
    BOOLEAN = 4,
}

export enum RequestFilterOperationTypeEnum {
    CONTAINS = 1,           // İçeriyor
    GREATER_THAN = 2,       // Büyüktür
    LOWER_THAN = 3,         // Küçüktür
    GREATER_AND_EQUAL = 4,  // Büyük veya eşittir
    LOWER_AND_EQUAL = 5,    // Küçük veya eşittir
    EQUALS = 6,             // Eşittir
    STARTS_WITH = 7,        // İle başlar
    ENDS_WITH = 8,          // İle biter
    IS_EMPTY = 9,           // Boş
    IS_NOT_EMPTY = 10,      // Boş değil
    IS_ANY = 11,             // Herhangi biri
    IS_NOT_EQUALS = 12,
    BETWEEN = 13,
}

export const accountTypeEnumStatic = [
    { value: 3, text: 'Tümü' },
    { value: 1, text: 'Bireysel' },
    { value: 2, text: 'Kurumsal' },
]


export const trueFalseWithoutNoneEnumValues = [
    { value: "1", text: 'Evet' },
    { value: "0", text: 'Hayır' },
]


export const trueFalseEnumValues = [
    { value: "1", text: 'Evet' },
    { value: "0", text: 'Hayır' },
    { value: null, text: 'Hepsi' },
]


export function mapReactMUIToFilterOperationTypes(muiType: String) {
    if (muiType === "contains") {
        return RequestFilterOperationTypeEnum.CONTAINS;
    }
    else if (muiType === "equals" || muiType === "=" || muiType === "is") {
        return RequestFilterOperationTypeEnum.EQUALS;
    } else if (muiType === "!=" || muiType === "not") {
        return RequestFilterOperationTypeEnum?.IS_NOT_EQUALS;
    } else if (muiType === "endsWith") {
        return RequestFilterOperationTypeEnum.ENDS_WITH;
    } else if (muiType === "startsWith") {
        return RequestFilterOperationTypeEnum.STARTS_WITH;
    } else if (muiType === "isEmpty") {
        return RequestFilterOperationTypeEnum.IS_EMPTY;
    } else if (muiType === "isNotEmpty") {
        return RequestFilterOperationTypeEnum.IS_NOT_EMPTY;
    } else if (muiType === "isAnyOf") {
        return RequestFilterOperationTypeEnum.IS_ANY;
    } else if (muiType === "between" || muiType === "onOrAfter" || muiType === "before" || muiType === "onOrAfter" || muiType === "after") {
        return RequestFilterOperationTypeEnum.BETWEEN;
    } else if (muiType === ">") {
        return RequestFilterOperationTypeEnum.GREATER_THAN;
    } else if (muiType === "<") {
        return RequestFilterOperationTypeEnum.LOWER_THAN;
    } else if (muiType === ">=") {
        return RequestFilterOperationTypeEnum.GREATER_AND_EQUAL;
    } else if (muiType === "<=") {
        return RequestFilterOperationTypeEnum.LOWER_AND_EQUAL;
    } else {
        return RequestFilterOperationTypeEnum.EQUALS;
    }
}

function isIsoDate(str: string) {
    if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false;
    const d = new Date(str);
    return !isNaN(d.getTime()) && d.toISOString() === str; // valid date 
}



export function mapReactFilterValueTypeToRequestFilterValueType(value: any, type?: any) {
    
    if (isIsoDate(value) || type === "datetime")//string date kontrolü yapıyor.
        return RequestFilterValueTypeEnums.DATE;

    if (value === "true" || value === "false") {
        return RequestFilterValueTypeEnums.BOOLEAN;
    }
    /*   if (!isNaN(value)) {
          return RequestFilterValueTypeEnums.NUMBER;
      } */
    if (typeof value === "string" || type === "singleSelect") {
        return RequestFilterValueTypeEnums.STRING;
    } else if (typeof value === "boolean") {
        return RequestFilterValueTypeEnums.BOOLEAN;
    } else /* if (typeof value === "number") */ {
        return RequestFilterValueTypeEnums.NUMBER;
    }

}